import AdvancedReportPage, { DefaultActionPanel } from "./AdvancedReportPage";
import ReportHeader from "./ReportHeader";
import ReportPage from "./ReportPage";

export const HITS_PER_PAGE = 20;

export { ReportHeader, ReportPage, AdvancedReportPage, DefaultActionPanel };
